(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["il-buybox"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ilbb]').forEach(function (f) {
  var plan = f.querySelector('[data-ilbb-plan]'), go = f.querySelector('.ilbb-go');
  f.querySelectorAll('input[name="il_pay"]').forEach(function (r) {
    r.addEventListener('change', function () {
      if (r.value) { plan.value = r.value; plan.disabled = false; } else { plan.disabled = true; }
      if (go && r.dataset.label) go.textContent = r.dataset.label;
    });
  });
  var sumEl = f.querySelector('[data-ilbb-xsum]');
  function sum() {
    if (!sumEl) return;
    var t = 0, n = 0;
    f.querySelectorAll('[data-ilbb-extra]:checked').forEach(function (x) { t += +x.dataset.price || 0; n++; });
    sumEl.hidden = !n;
    if (n) sumEl.querySelector('b').textContent = '$' + (t / 100).toLocaleString('en-AU', { maximumFractionDigits: 2 }) + ' (' + n + (n > 1 ? ' items' : ' item') + ')';
  }
  f.addEventListener('change', sum); sum();
  f.addEventListener('submit', function (e) {
    var xs = [].slice.call(f.querySelectorAll('[data-ilbb-extra]:checked'));
    if (!xs.length || !window.fetch) return;
    e.preventDefault();
    var main = { id: +f.querySelector('input[name="id"]').value, quantity: 1 };
    if (plan && !plan.disabled && plan.value) main.selling_plan = +plan.value;
    var items = [main].concat(xs.map(function (x) { return { id: +x.value, quantity: 1 }; }));
    if (go) go.disabled = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error(r.status); window.location.href = root + 'cart'; })
      .catch(function () { if (go) go.disabled = false; HTMLFormElement.prototype.submit.call(f); });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["il-pdp"] && !Shopify.designMode) return;
  try {
    
(function () {
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-pdp]').forEach(function (root) {
    var gal = root.querySelector('[data-pdp-gal]'); if (!gal) return;
    var track = gal.querySelector('.pg-track'), slides = [].slice.call(gal.querySelectorAll('.pg-slide'));
    var cur = gal.querySelector('[data-pg-cur]'), tot = gal.querySelector('[data-pg-total]'), bar = gal.querySelector('[data-pg-bar]');
    var prev = gal.querySelector('.pg-prev'), next = gal.querySelector('.pg-next'), thumbsEl = gal.querySelector('.pg-thumbs');
    var n = slides.length, at = 0;
    function pad(i) { return '' + i; }
    if (tot) tot.textContent = pad(n);
    var thumbs = slides.map(function (s, i) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'pg-th'; b.setAttribute('role', 'tab');
      b.setAttribute('aria-label', 'Photo ' + (i + 1) + (s.dataset.cap ? ': ' + s.dataset.cap : ''));
      var im = s.querySelector('img'); if (im) { var t = document.createElement('img'); t.alt = ''; t.loading = 'lazy'; t.src = (im.currentSrc || im.src).replace(/width=\d+/, 'width=200'); b.appendChild(t); }
      b.addEventListener('click', function () { go(i); });
      thumbsEl.appendChild(b); return b;
    });
    function setActive(i) {
      at = i; if (cur) cur.textContent = pad(i + 1);
      thumbs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      var t = thumbs[i]; if (t) { var box = thumbsEl; box.scrollTo({ left: t.offsetLeft - box.clientWidth / 2 + t.clientWidth / 2, behavior: RM ? 'auto' : 'smooth' }); }
      if (prev) prev.disabled = i === 0; if (next) next.disabled = i === n - 1;
    }
    function go(i) { i = clamp(i, 0, n - 1); track.scrollTo({ left: i * track.clientWidth, behavior: RM ? 'auto' : 'smooth' }); }
    var ticking = false;
    function frame() {
      ticking = false;
      var w = track.clientWidth || 1, x = track.scrollLeft, p = x / w;
      if (bar) bar.style.width = (n > 1 ? (p / (n - 1)) * 100 : 100) + '%';
      if (!RM) slides.forEach(function (s, k) {
        var d = clamp(k - p, -1, 1), im = s.firstElementChild; if (!im) return;
        im.style.setProperty('--px', (d * 18) + '%');
        im.style.setProperty('--sc', (1 + Math.abs(d) * 0.08).toFixed(3));
      });
      var i = Math.round(p); if (i !== at) setActive(i);
    }
    track.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, { passive: true });
    window.addEventListener('resize', frame);
    if (prev) prev.addEventListener('click', function () { go(at - 1); });
    if (next) next.addEventListener('click', function () { go(at + 1); });
    track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); go(at + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(at - 1); } if (e.key === 'Enter') { e.preventDefault(); lbOpen(at); } });
    /* mouse drag on desktop */
    var down = false, sx = 0, sl = 0, moved = 0;
    track.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = 0; sx = e.clientX; sl = track.scrollLeft; track.classList.add('drag'); });
    window.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; moved = Math.max(moved, Math.abs(dx)); track.scrollLeft = sl - dx; });
    window.addEventListener('pointerup', function () { if (!down) return; down = false; track.classList.remove('drag'); var p = track.scrollLeft / track.clientWidth, i = Math.round(p); if (Math.abs(p - at) > 0.15) i = p > at ? Math.ceil(p) : Math.floor(p); go(i); });
    /* lightbox */
    var lb = root.querySelector('[data-pg-lb]'), lbi = lb && lb.querySelector('img'), lbc = lb && lb.querySelector('[data-pg-lb-cap]'), li = 0, lastF = null;
    function lbShow(i) { li = (i + n) % n; var s = slides[li]; lbi.src = s.dataset.full; lbi.alt = s.dataset.cap || ''; if (lbc) lbc.textContent = (s.dataset.cap ? s.dataset.cap + '  ·  ' : '') + (li + 1) + ' of ' + n; }
    function lbOpen(i) { if (!lb) return; lastF = document.activeElement; lbShow(i); lb.hidden = false; document.documentElement.style.overflow = 'hidden'; lb.querySelector('.pg-lb-x').focus(); }
    function lbClose() { lb.hidden = true; document.documentElement.style.overflow = ''; go(li); if (lastF) lastF.focus(); }
    if (lb) {
      slides.forEach(function (s, i) { s.addEventListener('click', function () { if (moved < 6) lbOpen(i); }); });
      root.querySelector('.pg-zoom').addEventListener('click', function () { lbOpen(at); });
      lb.querySelector('.pg-lb-x').addEventListener('click', lbClose);
      lb.querySelector('.pg-lb-p').addEventListener('click', function () { lbShow(li - 1); });
      lb.querySelector('.pg-lb-n').addEventListener('click', function () { lbShow(li + 1); });
      lb.addEventListener('click', function (e) { if (e.target === lb) lbClose(); });
      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') lbClose();
        if (e.key === 'ArrowRight') lbShow(li + 1);
        if (e.key === 'ArrowLeft') lbShow(li - 1);
        if (e.key === 'Tab') { var f = [].slice.call(lb.querySelectorAll('button')); var a = f[0], z = f[f.length - 1]; if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); } }
      });
      var tx = null; lb.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', function (e) { if (tx === null) return; var dx = e.changedTouches[0].clientX - tx; if (Math.abs(dx) > 40) lbShow(li + (dx < 0 ? 1 : -1)); tx = null; });
    }
    setActive(0); frame();

    /* pay toggle + submit */
    var f = root.querySelector('[data-pdp-form]');
    if (f) {
      var plan = f.querySelector('[data-pdp-plan]'), btn = f.querySelector('.pdp-go');
      f.querySelectorAll('input[name="pdp_pay"]').forEach(function (r) {
        r.addEventListener('change', function () {
          if (r.value) { plan.value = r.value; plan.disabled = false; } else { plan.disabled = true; }
          if (btn && r.dataset.label) btn.textContent = r.dataset.label;
        });
      });
      var xsum = f.querySelector('[data-pdp-xsum]'), xd = xsum ? xsum.textContent : '';
      f.addEventListener('change', function (e) {
        if (!e.target.matches || !e.target.matches('[data-ilbb-extra]') || !xsum) return;
        var t = 0, k = 0; f.querySelectorAll('[data-ilbb-extra]:checked').forEach(function (x) { t += +x.dataset.price || 0; k++; });
        xsum.textContent = k ? k + ' added · +$' + (t / 100).toLocaleString('en-AU', { maximumFractionDigits: 2 }) : xd;
      });
      f.addEventListener('submit', function (e) {
        var xs = [].slice.call(f.querySelectorAll('[data-ilbb-extra]:checked'));
        if (!xs.length || !window.fetch) return;
        e.preventDefault();
        /* A normal form post, not fetch: store apps wrap fetch and XHR for cart adds and can leave them hanging */
        var nf = document.createElement('form'), k = 0, rt = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        nf.method = 'post'; nf.action = rt + 'cart/add'; nf.style.display = 'none';
        function put(n, v) { var i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v; nf.appendChild(i); }
        put('items[0][id]', f.querySelector('input[name="id"]').value); put('items[0][quantity]', 1);
        if (plan && !plan.disabled && plan.value) put('items[0][selling_plan]', plan.value);
        xs.forEach(function (x) { k++; put('items[' + k + '][id]', x.value); put('items[' + k + '][quantity]', 1); });
        if (btn) btn.disabled = true;
        document.body.appendChild(nf);
        HTMLFormElement.prototype.submit.call(nf);
      }, true);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
